export { default as createStore, } from './createStore';
export { default as combineReducers, } from './combineReducers';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/small-redux/es5-esm/index.js
// module id = U8YX
// module chunks = 3 10